import last from 'lodash/last';
import isEmpty from 'lodash/isEmpty';

export const CDN_RESOURCE_URL = getCDNResourceURL();
const CREDENTIALS = {
  production: {
    fcbhKey: 'ZmNiaF9jNzA0YTg0MS0zZjJk',
  },
  staging: {
    fcbhKey: 'ZmNiaHN0XzNiMGMxYTJkLTRlNWY=', 
  },
};

const PAYMENT_API_BASE_URL = {
  production: "https://fcbhwebsiteapi.azurewebsites.net",
  staging: "https://fcbhwebsiteapi-staging.azurewebsites.net", // "https://fcbhwebsiteapi-dev.azurewebsites.net",   // "https://localhost:7280", // "https://localhost:7280", //     
};

const LANG_PATH = {
  x_default: "",
  en_US: "",
  zh_TW: "/zh-hk",
};

export const getPaymentProcessorBaseURL = () => {
  return PAYMENT_API_BASE_URL[getEnvironment()];
};

function getCDNResourceURL() {
  if (window.location.hostname.startsWith("localhost")) return "http://localhost/cdn.faithcomesbyhearing.com/resources/fcbh/js/library/";
  return "https://cdn.faithcomesbyhearing.com/resources/fcbh/js/library/"
}
export function capitalize(sentence) {
    return sentence.charAt(0).toUpperCase() + sentence.slice(1).toLowerCase()
}

export function formatDonationText(amount) {
    const amountWithCommasRegex = /(\d)(?=(\d\d\d)+(?!\d))/g
    const amountParsed = (amount % 1) !== 0 ? amount.toFixed(2).replace(amountWithCommasRegex, "$1,") : amount.toString().replace(amountWithCommasRegex, "$1,")
    return amountParsed
}

export const getFormCampaign = ( objName ) => {
    let campaign = last(window.location.href.split('/'));
    campaign = campaign.split('#')[0];
    campaign = campaign.split('?')[0];

    return { 
        campaign,
        localForm: `${objName}/${campaign}`
    };
};

export const saveFormCampaignGIVE_FORM = ( localForm ) => {
    // save the campaign form reference in the local storage FCBH.GIVE_FORM before payment processment
    //to be managed by successful payment page

    FCBH.deleteFromStorage(FCBH.GIVE_FORM);
    FCBH.saveToStorage(FCBH.GIVE_FORM, {localForm: localForm});
};
export const getEnvironment = () => {
    if (window.location.hostname.startsWith("www.faithcomesbyhearing.com") || window.location.hostname.startsWith("www.faithcomesbyhearing.asia") ) {
        return "production";
    }
    return "staging";
}

export const isUSSite = () => {
   let locationPath = window.location.href.split('/'); 
    return window.location.hostname.startsWith("www.faithcomesbyhearing.com") 
      || locationPath.includes("www.faithcomesbyhearing.com") 
      || window.location.hostname.startsWith("fcbh.webflow.io") ;
}

const  shouldRetry = (error) => {
    if (error.status == 401 || error.status == 403) {
      removeCredentials();
      return true;
    }
    return false; 
  }

async function retryConvertCurrencAsync(fn, fromCurrency, toCurrency, fromAmount, shouldRetry) {
    const retries = 3;
    const delay = 500;
    for (let i = 0; i < retries; i++) {
      try {
        return await fn(fromCurrency, toCurrency, fromAmount); // Pass the original arguments to the function
      } catch (error) {
        if (!shouldRetry(error) || i === retries - 1) {
          throw error;
        }
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
}

/**
 * Get's converted amount from server
 * @param {String} fromCurrency
 * @param {String} toCurrency
 * @param {String} fromAmount
 */
export async function convertCurrency(fromCurrency, toCurrency, fromAmount) {
  const response = await retryConvertCurrencAsync(convertCurrencyRetriable, fromCurrency, toCurrency, fromAmount, shouldRetry );
  return response;
}
 async function convertCurrencyRetriable(fromCurrency, toCurrency, fromAmount) {
  const URL =  `${getPaymentProcessorBaseURL()}/Currency/Convert`;
  const currency_convert_post_url = URL;

  fromAmount = String(fromAmount); 
  fromAmount = fromAmount.replace("$", "");
  fromAmount = String(fromAmount).replaceAll(",", "");
  let values = fromAmount.split("-");

  values.forEach((v, i) => {
    values[i] = parseFloat(v);
  });
  fromAmount = values.join("-");

  var apiKey = await credentials(false);

  const url = currency_convert_post_url + "/" + fromCurrency + "/" + toCurrency + "/" + fromAmount;
  try {
    const {data} = await fetchWithCredentials(url, apiKey);
    let results = (data+'')?.split("-");
    results.forEach((v, i) => {
      results[i] = parseFloat(String(v).replaceAll(",", "")).toFixed(2).toLocaleString('us-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    });
    return results.join("-");
  } catch (error) {
    console.error("Error converting currency:", error);
    //return await getConversion(fromCurrency, toCurrency, fromAmount);
    throw error;
  }
}

export async function removeCredentials() {
  removeCookie("transId");
}

export async function credentials(newCredential = true) {
  const URL = `${getPaymentProcessorBaseURL()}/Auth/FcbhDynKey`;
  let session = getSessionCookie();
  const env = getEnvironment();
  let cn = Buffer.from(CREDENTIALS[env].fcbhKey, 'base64').toString(); //atob(CREDENTIALS[env].fcbhKey);
  //let token ={headerName: null, value: null, cookieToken: null};
  if (newCredential) {
    removeCredentials();
  }

  try {
    let sec = getCookie("transId");
    if (!sec) {//if transaction id is expired, get anew one
      var credential = {
          'Authentication': Buffer.from(session).toString('base64'),
      };
      const {data} = await fetchWithCredentials( URL, credential);
      var key = data.key;
      var transId = session + "_" + Buffer.from(key, 'base64').toString();
      sec = Buffer.from(transId).toString('base64');
      if(key.length > 18) {
        setCookie("transId", sec, 5 * 60 * 1000);
      }
    }

    var decSec = Buffer.from(sec, 'base64').toString();
    var parts = decSec.split("_");
    session = parts[0];
    var transkey = parts.length > 2 ?parts.shift().join("_") : parts[1];

    var dynkey = Buffer.from(cn + "_" + transkey).toString('base64');// btoa(cn + "_" + transkey); 

    var cred = {
    'x-api-key': dynkey,
    'Authentication': Buffer.from(session).toString('base64')
    };

    return cred;

  } catch (error) {
    console.error("Error fetching credentials:", error);
    return {};
  }
}

export function getValueWithoutSymbol(value){
    return last(value?.split(/[$\s]+/));
}

export function getMeta(metaName) {
  const metas = document.getElementsByTagName('meta'); 
  for (let i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute('name') === metaName) {
      return metas[i].getAttribute('content');
    }
  }
  return '';
}

export function notEmpty(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return true;
    }
  }
  return false;
}

export function isEmptyObject(obj) {
  if (typeof obj === "object") {
    let empty = true;
    Object.keys( obj ).forEach(key => {
      if (typeof obj[key] === "object") {
        if(!isEmptyObject(obj[key])) empty = false;
      } else {
        if (!isEmpty(obj[key])) empty = false;
      }
    });
    return empty;
  }
  return isEmpty(obj);
}

export function deaccent( value ){
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g,"");
}

function fetchGet(url, credential = {}) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      type: "GET",
      headers: credential,
      dataType: false,
      withCredentials: true,
      success: function (json) {
        resolve({ data: json });
      },
      error: function (err) {
        reject(err);
      },
    });
  });
};

  // Replace axios w/ jQuery to avoid using two request libraries
 export function fetchWithCredentials(url, credential = {}) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url,
        type: "GET",
        headers: credential,
        dataType: false,
        withCredentials: true,
        success: function (json) {
          resolve({ data: json });
        },
        error: function (err) {
          reject(err);
        },
      });
    });
  };

export async function postWithCredentials(url, data, credential = {}) {
    return new Promise((resolve, reject) => {
      let extraParams = {};
      if (data instanceof FormData) {
        extraParams = {
          processData: false,
          contentType: false, // 'application/x-www-form-urlencoded; charset=UTF-8',
        };
      }
      $.ajax({
        url,
        headers: credential,
        type: "POST",
        data,
        processData: extraParams.processData,
        contentType: extraParams.contentType,
        withCredentials: true,
        success: function (json) {
          resolve({ data: json });
        },
        error: function (err) {
          reject(err);
        },
      });
    });
};

function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function setSessionCookie(sessionId) {
  setCookie("sessionId", sessionId, 30 * 24 * 60 * 60 * 1000);
}

function setCookie(key, value, expirationIn, sameSite = "strict") {
  const date = new Date();
  date.setTime(date.getTime() + expirationIn); // 30 days
  const expires = "expires=" + date.toUTCString();
  document.cookie = `${key}=${value}; ${expires}; path=/; samesite=${sameSite}`;
}

function getCookie(key) {
  const name = `${key}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(";");
  for (let i = 0; i < cookieArray.length; i++) {
    let cookiev = cookieArray[i].trim();
    if (cookiev.indexOf(name) === 0) {
      return cookiev.substring(name.length, cookiev.length);
    }
  }
  return null;
}

function removeCookie(key) {
  if(getCookie(key)) {
    const date = new Date();
    date.setTime(date.getTime() - 1); // Set expiration to the past
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${key}=; ${expires}; path=/; samesite=strict`;
  }
}

function getSessionCookie() {
  const name = "sessionId";
  const cookie = getCookie(name);
  
  if (cookie != null) {
      return cookie;
  }
    
  let sessionId = generateUUID();
  setSessionCookie(sessionId);
  
  return sessionId;
}